import {
  AllCategoriesDocument
} from '@transactions/graphql';
import type {DataProxy} from '@apollo/client';
import type {
  AllCategoriesQuery,
  FullCategoryFragment} from '@transactions/graphql';

export const addNewCategory = (
  store: DataProxy,
  newCategory: FullCategoryFragment,
) => {
  const data = store.readQuery<AllCategoriesQuery>({
    query: AllCategoriesDocument,
  });
  const categories: FullCategoryFragment[] = data?.allCategories || [];

  if (!categories.find((c) => c._id === newCategory._id)) {
    store.writeQuery({
      query: AllCategoriesDocument,
      data: {
        allCategories: [...categories, newCategory],
      },
    });
  }
};

export const removeCategory = (
  store: DataProxy,
  oldCategory: FullCategoryFragment,
) => {
  const data = store.readQuery<AllCategoriesQuery>({
    query: AllCategoriesDocument,
  });
  const categories: FullCategoryFragment[] = data?.allCategories || [];

  const index = categories.findIndex((c) => c._id === oldCategory._id);
  if (index !== -1) {
    store.writeQuery({
      query: AllCategoriesDocument,
      data: {
        allCategories: [
          ...categories.slice(0, index),
          ...categories.slice(index + 1),
        ],
      },
    });
  }
};
